import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import { BrowserRouter, Route,Router, Switch,Link } from 'react-router-dom'

export default class About extends Component {

    constructor(props){
        super(props);
    }

    render() {
        return (
            <div>
            <div className="about">
            <h3>USAQuake is a real time Earthquake App for the United States</h3>
            <img src="./usaquake orange.png"/>
            <h3>USAQuake Features:</h3>
            <ul>
              <li>Plots Earthquakes in real time using data from the USGS</li>
              <li>Audio alerts for large Earthquakes and possible Tsunamis</li>
              <li>View a list of the Earthquakes for that day</li>
            </ul>
           </div>

          <div className="download">
          <h3>System Requirements:</h3>
          <h4>1. Windows 10, MacOS or Linux</h4>
          <h4>2. You must have <a href="https://java.com/en/download/">Java</a> installed</h4>
          <h4>3. A Steady Internet Connection</h4>
          <h4>Download it here: <a target="_blank" href="https://github.com/bthompson7/usaquake/releases">USAQuake Downloads</a></h4>
          </div>
          </div>
        )
    }      
}